import { Services } from '@sigma-frontend-libs/commons'

import { components, labelModes } from '@/utils'

import buttonFilter from '@/components/button/filter'
import filterDate from '@/components/filter/date'
import selectorOwner from '@/components/selector/owner'
import { serviceNameKebabCase, serviceNameViaPoint } from '@/components/services/url-shortener-settings/presets/utils'

function renderDateFilter(h) {
  return h(
    filterDate,
    {
      props: {
        value: this.proxy.createdAt,
        preset: this.proxy.createdAtPreset,
        presets: true,
        clearable: true,
        backendGeneration: 'nest'
      },
      on: {
        input: event => {
          this.proxy.createdAt = event
        },
        preset: event => {
          this.proxy.createdAtPreset = event
        }
      }
    }
  )
}

function renderTitleField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.title,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.title`),
        dense: true,
        clearable: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.title = event
        }
      }
    }
  )
}
function renderDomainIdField(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.domainId,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.domainId`),
        service: Services['url-shortener-settings/domains'],
        itemTitle: 'name',
        dense: true,
        clearable: true,
        autocomplete: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.domainId = event
        }
      }
    }
  )
}
function renderOwnerField(h) {
  return h(
    selectorOwner,
    {
      props: {
        value: this.proxy.ownerId,
        labelMode: labelModes.hidden,
        dense: true
      },
      on: {
        input: event => {
          this.proxy.ownerId = event
        }
      }
    }
  )
}
function renderFields(h) {
  return [
    renderTitleField.call(this, h),
    renderDomainIdField.call(this, h),
    renderOwnerField.call(this, h)
  ]
}

function renderButtonFilter(h) {
  return h(
    buttonFilter,
    {
      props: {
        value: this.proxy,
        defaultValue: this.defaultFilter
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    },
    renderFields.call(this, h)
  )
}

function renderContentByViewport(h) {
  if (this.viewport.breakpoint.lgUp) {
    return renderButtonFilter.call(this, h)
  } else {
    return h(
      'div',
      {
        class: 'grid grid-gap--8'
      },
      renderFields.call(this, h)
    )
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-filter`
    },
    [
      renderDateFilter.call(this, h),
      renderContentByViewport.call(this, h)
    ]
  )
}
